export function setTextForServicesButton(text) {
    document.querySelector('.procedureContinue__btn').textContent = text;
}
